// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__1t0vg","loader":"ContentLoader_loader__POghB","disabled":"ContentLoader_disabled__Ks2_6"};